export const environment = {
  production: true,
  connection: {
    name: 'LH Sankt Michael Softline',
    host: 'https://softline.lagerhaus-stmichael.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
